module.exports = __webpack_public_path__ + "img/人才建设.922d379e.jpg";